"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../../gen-src/Localize");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var CredentialsHandler_1 = require("../CredentialsHandler");
var WorkbookFromTemplateFactory_1 = require("../WorkbookFromTemplateFactory");
var AvailableDeviceLayouts_1 = require("./AvailableDeviceLayouts");
var CRI_OS_REGEX = /CriOS/;
var CHROME = /Chrome/i;
var FIREFOX_REGEX = /Firefox/;
var SAFARI_REGEX = /Safari/;
var TemplateSelectMethods;
(function (TemplateSelectMethods) {
    TemplateSelectMethods.Button = 'button';
    TemplateSelectMethods.Image = 'image';
})(TemplateSelectMethods = exports.TemplateSelectMethods || (exports.TemplateSelectMethods = {}));
var WorkbookTemplateDescription = /** @class */ (function (_super) {
    __extends(WorkbookTemplateDescription, _super);
    function WorkbookTemplateDescription(props) {
        var _this = _super.call(this, props) || this;
        _this.disableButtons = function () {
            _this.setState({ buttonsDisabled: true });
        };
        _this.enableButtons = function () {
            _this.setState({ buttonsDisabled: false });
        };
        _this.setWindow = function (windowReference) {
            _this.setState({ windowReference: windowReference });
        };
        _this.onTemplateSelectedViaButton = function () {
            _this.props.onTemplateSelected(_this.props.template.id, _this.props.template.connectionType.internalName, TemplateSelectMethods.Button);
        };
        _this.isChrome = function (userAgent) {
            return CRI_OS_REGEX.test(userAgent) || CHROME.test(userAgent);
        };
        _this.isSafari = function () {
            return SAFARI_REGEX.test(navigator.userAgent) && !_this.isChrome(navigator.userAgent);
        };
        _this.isFirefox = function () {
            return FIREFOX_REGEX.test(navigator.userAgent) && !_this.isChrome(navigator.userAgent);
        };
        _this.isPopupBlockerBrowser = function () {
            return _this.isSafari() || _this.isFirefox();
        };
        _this.createWindowWithoutPopupBlocker = function () {
            // When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
            // This is because we are opening a new window and we have some asynchronously logic such as publishing the workbook.
            // to get around the pop up blocker we need to open the window first, then the window.location.href can be set asynchronously afterwards
            if (_this.isPopupBlockerBrowser()) {
                var windowReference = window.open();
                if (windowReference) {
                    _this.setWindow(windowReference);
                }
            }
        };
        _this.VizclientButton = function () {
            return (React.createElement(widgets_1.ButtonWidget, { testId: "select-template-" + _this.props.template.id, children: Localize_1.Messages.SelectTemplateButtonText(), buttonType: widgets_1.ButtonType.Outline, handleClick: _this.onTemplateSelectedViaButton }));
        };
        _this.handleCreateWorkbookWithSampleData = function () { return __awaiter(_this, void 0, void 0, function () {
            var noCredentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.props.sendTelemetry) {
                            this.props.sendTelemetry(this.props.template, true);
                        }
                        this.disableButtons();
                        noCredentials = '';
                        this.createWindowWithoutPopupBlocker();
                        return [4 /*yield*/, WorkbookFromTemplateFactory_1.WorkbookFromTemplateFactory.createWorkbookWithoutProjectSelection(this.props.template.name, noCredentials, this.props.template.id, this.props.template.connectionType, this.onTemplateCreated)];
                    case 1:
                        _a.sent();
                        this.setWindow(null);
                        this.enableButtons();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleCreateWorkbook = function () { return __awaiter(_this, void 0, void 0, function () {
            var noJumpstartTelemetry, bypassBeforeConnectionDialog, oauthCredentialsParams, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.props.sendTelemetry) {
                            this.props.sendTelemetry(this.props.template, false);
                        }
                        this.disableButtons();
                        noJumpstartTelemetry = undefined;
                        bypassBeforeConnectionDialog = true;
                        _b = (_a = CredentialsHandler_1.CredentialsHandler).getOauthCredentialsParams;
                        _c = [this.props.template.connectionType,
                            this.props.helpVersion ? this.props.helpVersion : '0.0.0.0',
                            this.onCredentialAdded];
                        _d = this.props.sessionRelevantInfo;
                        if (_d) return [3 /*break*/, 2];
                        return [4 /*yield*/, CredentialsHandler_1.CredentialsHandler.getSessionRelevantInfo()];
                    case 1:
                        _d = (_e.sent());
                        _e.label = 2;
                    case 2:
                        oauthCredentialsParams = _b.apply(_a, _c.concat([_d, noJumpstartTelemetry,
                            bypassBeforeConnectionDialog]));
                        if (!this.isPopupBlockerBrowser()) return [3 /*break*/, 3];
                        CredentialsHandler_1.CredentialsHandler.addCredentialsSync(oauthCredentialsParams);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, CredentialsHandler_1.CredentialsHandler.addCredentialsAsync(oauthCredentialsParams)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5:
                        this.enableButtons();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onCredentialAdded = function (credentialId, 
        // tslint:disable-next-line no-any
        credentialProperties // not used but the callback requires it
        ) { return __awaiter(_this, void 0, void 0, function () {
            var createWorkbookInNewTab;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        createWorkbookInNewTab = false;
                        return [4 /*yield*/, WorkbookFromTemplateFactory_1.WorkbookFromTemplateFactory.createWorkbookWithoutProjectSelection(this.props.template.name, credentialId, this.props.template.id, this.props.template.connectionType, this.onTemplateCreated, createWorkbookInNewTab)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onTemplateCreated = function (success, url, createWorkbookInNewTab) {
            // We need to take into considerations a few flows here since we want to support all browsers.
            // There are two flows that are calling to this method: creation of a template with sample data or creation of a template with user's data via sign in flow.
            // If we have reached this method from template creation with sample data then:
            //  - if the browser has pop up blocker detection then redirect the user to the workbook in a new tab that is in windowReference
            //  - if the browser doesn't have pop up blocker detection then redirect the user to the workbook in a new tab.
            // If we have reached this method from template creation with user's data then:
            //  - redirect the user without creating a new tab.
            if (createWorkbookInNewTab === void 0) { createWorkbookInNewTab = true; }
            if (_this.state.windowReference) {
                if (success === true) {
                    _this.state.windowReference.location.href = url;
                }
                else {
                    _this.state.windowReference.close();
                }
            }
            else if (success === true) {
                if (createWorkbookInNewTab) {
                    window.open("" + window.location.origin + url, '_blank');
                }
                else {
                    window.location.href = "" + window.location.origin + url;
                }
            }
            if (success === false && _this.props.onTemplateCreationFailed) {
                _this.props.onTemplateCreationFailed();
            }
        };
        _this.VpcButtons = function () {
            return (React.createElement("div", null,
                React.createElement(widgets_1.ButtonWidget, { testId: "use-sample-data-" + _this.props.template.id, children: Localize_1.Messages.UseSampleDataButtonText(), buttonType: widgets_1.ButtonType.Outline, handleClick: _this.handleCreateWorkbookWithSampleData, className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.UseSampleDataButton, disabled: _this.state.buttonsDisabled, title: Localize_1.Messages.TemplateDescriptionUseSampleDataButtonTitle({
                        TEMPLATE_NAME: _this.props.template.name,
                    }) }),
                React.createElement(widgets_1.ButtonWidget, { testId: "sign-in-" + _this.props.template.id, children: Localize_1.Messages.SignInToConnectionTypeButtonText({
                        CONNECTION_TYPE: _this.props.template.connectionType.displayName,
                    }), buttonType: widgets_1.ButtonType.Primary, handleClick: _this.handleCreateWorkbook, disabled: _this.state.buttonsDisabled, title: Localize_1.Messages.TemplateDescriptionSignInToButtonTitle({
                        CONNECTION_TYPE: _this.props.template.connectionType.displayName,
                        TEMPLATE_NAME: _this.props.template.name,
                    }) })));
        };
        _this.getButtons = function () {
            return _this.props.isVpc ? (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ButtonDiv }, _this.VpcButtons())) : (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ButtonDiv }, _this.VizclientButton()));
        };
        _this.descriptionNoButtons = function () {
            // TODO: fix this to get the values from the prop, need to convert string array to enum values.
            var hardcodedDevicesList = [AvailableDeviceLayouts_1.AvailableDevices.Laptop, AvailableDeviceLayouts_1.AvailableDevices.Phone];
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, Localize_1.Messages.DatasourceHeaderMessage()),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.ConnectionType }, _this.props.template.connectionType.displayName),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, _this.props.template.name),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDescriptionText }, _this.props.template.description),
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemTitle }, Localize_1.Messages.LayoutsHeaderMessage()),
                React.createElement(AvailableDeviceLayouts_1.AvailableDeviceLayouts, { availableDevices: hardcodedDevicesList })));
        };
        _this.state = { buttonsDisabled: false, windowReference: null };
        return _this;
    }
    WorkbookTemplateDescription.prototype.render = function () {
        // The list of available layouts is hardcoded for now. To be generalized with info returned by TAS
        return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsStyles.TemplateItemDescriptionDiv },
            this.descriptionNoButtons(),
            this.getButtons()));
    };
    return WorkbookTemplateDescription;
}(React.Component));
exports.WorkbookTemplateDescription = WorkbookTemplateDescription;
//# sourceMappingURL=TemplateDescription.js.map